import React, { useState, useEffect } from "react";
import SouthEastIcon from "@mui/icons-material/SouthEast";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import TrendingFlatIcon from "@mui/icons-material/TrendingFlat";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import NorthEastIcon from "@mui/icons-material/NorthEast";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import LoadingButton from "@mui/lab/LoadingButton";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import SaveIcon from "@mui/icons-material/Save";
import FormControl from "@mui/material/FormControl";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import CloseIcon from "@mui/icons-material/Close";
import ForecastAdjustmentSlider from "./ForecastAdjustmentSlider";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import EditIcon from "@mui/icons-material/Edit";
import WeatherEventsCard from "./WeatherEventsCard";
import ForecastAdjustmentDrawer from "./ForecastAdjustmentDrawer";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import Tooltip from "@mui/material/Tooltip";
import { get_t_str } from "../../../../helpers/helpers";
import AdvancedForecastingModal from "./AdvancedForecastingModal";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import AdjustmentsHistoryTooltip from "./AdjustmentsHistoryTooltip";

// Modal style object
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #E2E8F0",
  borderRadius: "15px",
  boxShadow: 24,
  p: 4,
};

// Icon for forecast adjustment
function adjustment_icon(value) {
  if (value < -0.2) {
    return <SouthEastIcon />;
  }
  if (value < 0) {
    return <TrendingDownIcon />;
  }
  if (value > 0.2) {
    return <NorthEastIcon />;
  }
  if (value > 0) {
    return <TrendingUpIcon />;
  } else {
    return <TrendingFlatIcon />;
  }
}

// Smaller icon for forecast adjustment
function adjustment_icon_small(value) {
  if (value.toFixed(3) === "0.000") {
    return "";
  }
  if (value < -0.2) {
    return <SouthEastIcon style={{ fontSize: "16px" }} />;
  }
  if (value < 0) {
    return <TrendingDownIcon style={{ fontSize: "16px" }} />;
  }
  if (value > 0.2) {
    return <NorthEastIcon style={{ fontSize: "16px" }} />;
  }
  if (value > 0) {
    return <TrendingUpIcon style={{ fontSize: "16px" }} />;
  } else {
    return "";
  }
}

function DateCardSalesInfo(props) {
  const initial_state =
    props.adjustment_chosen.length === 0
      ? 0
      : props.adjustment_chosen[0]["adjustment_percent_value"];

  const initial_reason =
    props.adjustment_chosen.length === 0
      ? ""
      : props.adjustment_chosen[0]["reason"];

  // Calculate initial forecast - handle manual initial forecast case
  const calculateInitialForecast = () => {
    if (
      props.adjustment_chosen.length > 0 &&
      props.forecast_sales === 0 &&
      props.adjustment_chosen[0]["sales_value"]
    ) {
      const manualValue = parseFloat(props.adjustment_chosen[0]["sales_value"]);
      if (!isNaN(manualValue) && manualValue > 0) {
        return manualValue; // Use sales_value directly for manual initial
      }
    }
    return props.forecast_sales * initial_state + props.forecast_sales; // Normal percentage calculation
  };
  const initial_forecast = calculateInitialForecast();

  // // Shows modal when true
  // const [open, setOpen] = React.useState(false);

  // // Function for opening the modal
  // const handleOpen = () => setOpen(true);

  const [state, setState] = React.useState("");
  const [value, setValue] = React.useState(initial_state);
  const [savingLoading, setSavingLoading] = React.useState(false);
  const isFutureDay = !props.day_in_past && !props.todays_date_yes;

  const [adjustedForecast, setAdjustedForecast] = React.useState(
    initial_forecast.toFixed(0)
  );

  // Reason why the manager adjusted the forecasted
  const [reason, setReason] = React.useState(initial_reason);

  function toggleLocked() {
    props.lock_day(props.d);
  }

  useEffect(() => {
    const initial_state =
      props.adjustment_chosen.length === 0
        ? 0
        : props.adjustment_chosen[0]["adjustment_percent_value"];
    const initial_reason =
      props.adjustment_chosen.length === 0
        ? ""
        : props.adjustment_chosen[0]["reason"];
    // Calculate initial forecast - handle manual initial forecast case
    const initial_forecast =
      props.adjustment_chosen.length > 0 &&
      props.forecast_sales === 0 &&
      props.adjustment_chosen[0]["sales_value"] &&
      parseFloat(props.adjustment_chosen[0]["sales_value"]) > 0
        ? parseFloat(props.adjustment_chosen[0]["sales_value"])
        : props.forecast_sales * initial_state + props.forecast_sales;

    setValue(initial_state);
    setReason(initial_reason);
    setAdjustedForecast(initial_forecast.toFixed(0));
  }, [props.adjustment_chosen, props.forecast_sales]);

  function handleClose() {
    const initial_state =
      props.adjustment_chosen.length === 0
        ? 0
        : props.adjustment_chosen[0]["adjustment_percent_value"];
    const initial_reason =
      props.adjustment_chosen.length === 0
        ? ""
        : props.adjustment_chosen[0]["reason"];
    const initial_forecast =
      props.forecast_sales * initial_state + props.forecast_sales;

    setValue(initial_state);
    setReason(initial_reason);
    setAdjustedForecast(initial_forecast.toFixed(0));
    setShowForecastAdjustmentInputs(false);
    props.setOpenForecastAdjustment(false);
  }

  // Function for submitting the form within the modal
  function submitAndClose() {
    setSavingLoading(true);
    let add_type = "new";
    let data = {
      date: props.date_str,
      adjustments_chosen: "adjust",
      adjustment_percent_value: value,
      sales_value: adjustedForecast,
      reason: value === 0 ? "" : reason,
    };

    if (props.adjustment_chosen.length > 0) {
      add_type = "edit";
      data = props.adjustment_chosen[0];
      data["adjustment_percent_value"] = value;
      data["sales_value"] = adjustedForecast;
      data["reason"] = value === 0 ? "" : reason;
    }

    props.addForecastAdjustment(data, add_type);
  }

  useEffect(() => {
    if (props.addAdjustmentFinished) {
      setSavingLoading(false);
      props.setOpenForecastAdjustment(false);
    }
  }, [props.addAdjustmentFinished]);

  let actualColor = "";
  if (initial_forecast <= props.actual_sales) {
    actualColor = "bg-emerald-50 text-emerald-700";
  } else {
    actualColor = "bg-rose-50 text-rose-700";
  }

  // Calculate the percent difference
  const calculatePercentDifference = (actual, forecasted) => {
    const difference = actual - forecasted;
    const average = (actual + forecasted) / 2;
    const relativeDifference = difference / average;
    const percentDifference = relativeDifference * 100;

    return percentDifference;
  };

  const percentDifference = calculatePercentDifference(
    initial_forecast,
    props.forecast_sales
  );

  const [showForecastAdjustmentInputs, setShowForecastAdjustmentInputs] =
    React.useState(false);

  function toggleShowForecastAdjustmentInputs() {
    setShowForecastAdjustmentInputs((prevState) => !prevState);
  }

  const fullDayNameLookup = {
    Mon: "Monday",
    Tue: "Tuesday",
    Wed: "Wednesday",
    Thu: "Thursday",
    Fri: "Friday",
    Sat: "Saturday",
    Sun: "Sunday",
  };

  const fullDayString = fullDayNameLookup[props.date_name?.substring(0, 3)];

  const isHoliday = props.historical_sales_context?.[0]?.holidays?.length > 0;

  const isClosed = props.specialHours
    ? props.specialHours?.open_time === 0 &&
      props.specialHours?.close_time === 0
    : props.defaultHours?.open_time === 0 &&
      props.defaultHours?.close_time === 0;

  const hooString = `${get_t_str(props.hoo?.open_time)} - ${get_t_str(
    props.hoo?.close_time
  )}`;
  const specialHoursString = `${get_t_str(
    props.specialHours?.open_time
  )} - ${get_t_str(props.specialHours?.close_time)}`;

  // Advanced forecasting

  const [openAdvancedForecastingModal, setOpenAdvancedForecastingModal] =
    React.useState(false);
  const handleOpenAdvancedForecastingModal = () =>
    setOpenAdvancedForecastingModal(true);
  const handleCloseAdvancedForecastingModal = () =>
    setOpenAdvancedForecastingModal(false);

  const adjustments_history_manual = props.adjustments_history?.filter(
    (adjustment) => adjustment?.adjustment_origin === "manual"
  );
  const adjustments_history_internal = props.adjustments_history?.filter(
    (adjustment) => adjustment?.adjustment_origin === "internal"
  );

  // Check if we have a manual initial forecast (forecast_sales is 0 but user set a manual value)
  const hasManualInitialForecast =
    props.forecast_sales === 0 &&
    props.manualSalesInputEnabled &&
    props.adjustment_chosen.length > 0 &&
    props.adjustment_chosen[0]["sales_value"] &&
    parseFloat(props.adjustment_chosen[0]["sales_value"]) > 0;

  return (
    <div>
      {props.view === "weekly" ? (
        !props.minimizeMode && !(props.isFixed && props.isHeaderCollapsed) ? (
          <div>
            {props.edit_mode || isFutureDay ? (
              <div className="w-full">
                <Tooltip
                  title={
                    isHoliday
                      ? `${
                          props.historical_sales_context?.[0]?.holidays?.[0]
                            ?.holiday_name
                        }: ${isClosed ? "Closed" : hooString}`
                      : isClosed
                      ? ""
                      : props.specialHours
                      ? `Special Hours: ${specialHoursString}`
                      : ""
                  }
                >
                  <div
                    data-help-id="schedule-forecasted-sales"
                    className={`mt-2 flex items-center hover:text-violet-700 cursor-pointer ${
                      isHoliday
                        ? "bg-amber-50 px-1.5 rounded-lg w-full"
                        : isClosed
                        ? "bg-slate-100 px-1.5 rounded-lg w-full"
                        : props.specialHours
                        ? "bg-blue-50 px-1.5 rounded-lg w-full"
                        : ""
                    }`}
                    onClick={() => props.handleOpenForecastAdjustment()}
                  >
                    {/* <IconButton
                    onClick={handleOpen}
                    style={{ color: props.todays_date_yes && "#2563eb" }}
                  > */}
                    {/* {adjustment_icon(value)} */}
                    {/* </IconButton> */}
                    <div>
                      <div className="text-xxs text-slate-500">Forecasted</div>
                      {isClosed ? (
                        <div className="text-xs xl:text-xxs py-0.5">Closed</div>
                      ) : (
                        <div className="flex items-center">
                          <div className="text-xs xl:text-xxs py-0.5">
                            {"$" +
                              initial_forecast.toLocaleString(undefined, {
                                maximumFractionDigits: 0,
                              })}
                          </div>
                          <div className="w-4 h-4 relative">
                            <p className="absolute -bottom-0.5">
                              {adjustment_icon_small(initial_state)}
                            </p>
                          </div>
                          {/* <p className="absolute -right-1 -bottom-0.5">{adjustment_icon_small(value)}</p> */}
                        </div>
                      )}
                    </div>
                  </div>
                </Tooltip>
              </div>
            ) : (
              <Tooltip
                title={
                  isHoliday
                    ? `${
                        props.historical_sales_context?.[0]?.holidays?.[0]
                          ?.holiday_name
                      }: ${isClosed ? "Closed" : hooString}`
                    : isClosed
                    ? ""
                    : props.specialHours
                    ? `Special Hours: ${specialHoursString}`
                    : ""
                }
              >
                <div
                  data-help-id="schedule-forecasted-sales"
                  className={`mt-2 flex items-center justify-between hover:text-violet-700 cursor-pointer ${
                    isHoliday
                      ? "bg-amber-50 px-1.5 rounded-lg"
                      : isClosed
                      ? "bg-slate-100 px-1.5 rounded-lg w-full"
                      : props.specialHours
                      ? "bg-blue-50 px-1.5 rounded-lg w-full"
                      : ""
                  }`}
                  onClick={() => props.handleOpenForecastAdjustment()}
                >
                  {props.windowWidth > 1100 && (
                    <div>
                      <div className="text-xxs text-slate-500">Forecasted</div>
                      {isClosed ? (
                        <div className="text-xs xl:text-xxs py-0.5">Closed</div>
                      ) : (
                        <div className="flex items-center">
                          <div className="text-xs xl:text-xxs py-0.5">
                            {"$" +
                              initial_forecast.toLocaleString(undefined, {
                                maximumFractionDigits: 0,
                              })}
                          </div>
                          <div className="w-4 h-4 relative">
                            <p className="absolute -bottom-0.5">
                              {adjustment_icon_small(value)}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  <div>
                    <div
                      className={`text-xxs ${
                        props.windowWidth > 1100 ? "text-right" : "text-left"
                      } text-slate-500`}
                    >
                      Actual
                    </div>
                    <div
                      className={`text-xs xl:text-xxs text-center py-0.5 px-1 rounded-md ${actualColor}`}
                    >
                      {"$" +
                        props.actual_sales.toLocaleString(undefined, {
                          maximumFractionDigits: 0,
                        })}
                    </div>
                  </div>
                </div>
              </Tooltip>
            )}
          </div>
        ) : (
          <div></div>
        )
      ) : (
        <div className="flex items-center gap-5">
          <Tooltip
            title={
              isHoliday
                ? `${
                    props.historical_sales_context?.[0]?.holidays?.[0]
                      ?.holiday_name
                  }: ${isClosed ? "Closed" : hooString}`
                : isClosed
                ? ""
                : props.specialHours
                ? `Special Hours: ${specialHoursString}`
                : ""
            }
          >
            <button
              type="button"
              data-help-id="schedule-forecasted-sales"
              onClick={() => props.handleOpenForecastAdjustment()}
              className={`group h-[26px] inline-flex items-center gap-1.5 rounded-md px-1.5 -mx-1.5 hover:bg-slate-100 ${
                isHoliday ? "bg-amber-50" : ""
              }`}
            >
              <span className="text-xxs leading-none text-slate-400">Forecast</span>
              <span className="text-sm leading-none font-semibold text-slate-900 tabular-nums inline-flex items-center gap-0.5">
                {adjustment_icon_small(
                  props.edit_mode || isFutureDay ? initial_state : value
                )}
                {"$" +
                  initial_forecast.toLocaleString(undefined, {
                    maximumFractionDigits: 0,
                  })}
              </span>
              <EditIcon
                style={{ fontSize: "12px" }}
                className="text-slate-400 group-hover:text-violet-700 self-center"
              />
            </button>
          </Tooltip>
          {!(props.edit_mode || isFutureDay) && (
            <span className="h-[26px] inline-flex items-center gap-1.5">
              <span className="text-xxs leading-none text-slate-400">Actual</span>
              <span
                className={`h-[22px] inline-flex items-center text-sm leading-none font-semibold tabular-nums px-1.5 rounded ${actualColor}`}
              >
                {"$" +
                  props.actual_sales.toLocaleString(undefined, {
                    maximumFractionDigits: 0,
                  })}
              </span>
            </span>
          )}
        </div>
      )}
      <ForecastAdjustmentDrawer
        open={props.openForecastAdjustment}
        setOpenForecastAdjustment={props.setOpenForecastAdjustment}
        forecast_sales={props.forecast_sales}
        actual_sales={props.actual_sales}
        adjustment_chosen={props.adjustment_chosen}
        adjustments_history={props.adjustments_history}
        manualSalesInputEnabled={props.manualSalesInputEnabled}
        day_in_past={props.day_in_past}
        date_name={props.date_name}
        date_str={props.date_str}
        historical_sales_context={props.historical_sales_context}
        reservation_summary={props.daily_reservation_summary}
        reservation_summaries={props.reservation_summary}
        hooString={hooString}
        isClosed={isClosed}
        fullDayString={fullDayString}
        hoo={props.hoo}
        addForecastAdjustment={props.addForecastAdjustment}
        addManualActualSales={props.addManualActualSales}
        addAdjustmentFinished={props.addAdjustmentFinished}
        onOpenAdvancedModal={handleOpenAdvancedForecastingModal}
      />
      <AdvancedForecastingModal
        open={openAdvancedForecastingModal}
        handleClose={handleCloseAdvancedForecastingModal}
        date_name={props.date_name}
        initial_forecast={props.forecast_sales}
        adjusted_forecast={
          props.forecast_sales * initial_state + props.forecast_sales
        }
        hooString={hooString}
        isClosed={isClosed}
        daily_intraday_metrics={props.daily_intraday_metrics}
        actual_intraday_metrics={props.actual_intraday_metrics}
        icon_value={initial_state}
        actual_sales={props.actual_sales}
        isToday={props.todays_date_yes}
      />
    </div>
  );
}

export default DateCardSalesInfo;
